import {BaseButton} from 'iebt-zing-storybook'
import React from 'react'
import { useSmartNavigateLegacy as useNavigate } from 'components/SmartLink'
import {hasAccess} from 'sharedKernel/auth/behavior'
import {trans} from 'sharedKernel/i18n'
import {LaunchIdeaButtonProps} from '../contracts'
import {caixaUser} from 'sharedKernel/user/CaixaUser'

export const LaunchIdeaButton = ({
                                     challengeId,
                                     remainingAttempts,
                                     preview = false
                                 }: LaunchIdeaButtonProps): JSX.Element => {
    const navigate = useNavigate()

    const btnText = trans('Inscreva-se')

    const haveAccess = hasAccess('idea', 'launch') || (caixaUser.isCaixaUser() && caixaUser.hasPermission('idea', 'launch'))
    if (!haveAccess || remainingAttempts < 1) {
        return <></>
    }

    const handleLaunchIdea = (): void => {
        if (!preview) {
            navigate(`/hub/startup/challenge/${String(challengeId)}/apply`)
        }
    }

    return (
        <div className="pb-4">
            <BaseButton
                btnContent={btnText}
                variant="primary"
                size="big"
                isFullWidth
                onClick={() => handleLaunchIdea()}
            />
        </div>
    )
}
